import axios from "axios";
import i18n from "@/plugins/i18n";
// axios.defaults.baseURL = `https://staging.api.designedvr.com/api/booking`;
axios.defaults.baseURL = `/api/booking`;

// Add request interceptor to include booking_session_id and language
axios.interceptors.request.use((config) => {
  const bookingSessionId = localStorage.getItem("booking_session_id");
  const currentLanguage = i18n.locale;

  if (config.method?.toLowerCase() === "get") {
    config.params = {
      ...config.params,
      language: currentLanguage,
    };

    if (bookingSessionId) {
      config.params = {
        ...config.params,
        booking_session_id: bookingSessionId,
      };
    }
  } else {
    config.data = {
      ...config.data,
      language: currentLanguage,
    };

    if (bookingSessionId) {
      config.data = {
        ...config.data,
        booking_session_id: bookingSessionId,
      };
    }
  }

  return config;
});

export { axios };
